import { GetMpsProductDetailResponse } from '@services/MarppleShop/features/product-detail/dto';
import {
  createFundingDetailBadges,
  createProductDetailBadges,
} from '@services/MarppleShop/renderApp/components/cells/ProductBadge';
import { isTplProductData } from '@shared/product';
import { isLegacyStockProductData } from '@services/MarppleShop/features/ProductList';

/**
 * @mps-only
 *
 * - 마플샵 - 상품상세
 * - 마플 상품 상세 페이지 상품 뱃지 생성을 위해 props 만들어주는 어댑터
 * - 상품상세가 js 라서 ts로 파일을 생성했습니다.
 */
export const convertToMpsBadgeListProps = (productDetail: Readonly<GetMpsProductDetailResponse>) => {
  if (productDetail.status.isFunding) {
    if (isTplProductData(productDetail)) {
      return createFundingDetailBadges(
        {
          status: productDetail.status,
          goodsTypeId: productDetail.goodsTypeId,
          salePeriod: {
            startDate: productDetail.salePeriod.startDate ?? undefined,
            endDate: productDetail.salePeriod.endDate ?? undefined,
          },
          stock: productDetail.stock,
          publicAt: productDetail.publicAt,
          outOfStock: productDetail.outOfStock,
          limitedMeta: productDetail.limitedMeta ?? undefined,
          lowStockMeta: productDetail.lowStockMeta ?? undefined,
        },
        Date.now(),
      );
    } else {
      throw new Error(`펀딩 상품은 입고 상품인 경우만 지원합니다. ${productDetail.goodsTypeId}`);
    }
  } else {
    if (isLegacyStockProductData(productDetail)) {
      return createProductDetailBadges(
        {
          status: productDetail.status,
          goodsTypeId: productDetail.goodsTypeId,
          salePeriod: {
            startDate: productDetail.salePeriod.startDate ?? undefined,
            endDate: productDetail.salePeriod.endDate ?? undefined,
          },
          legacyStock: productDetail.legacyStock,
          publicAt: productDetail.publicAt,
          outOfStock: productDetail.outOfStock,
        },
        Date.now(),
      );
    } else {
      return createProductDetailBadges(
        {
          status: productDetail.status,
          goodsTypeId: productDetail.goodsTypeId,
          salePeriod: {
            startDate: productDetail.salePeriod.startDate ?? undefined,
            endDate: productDetail.salePeriod.endDate ?? undefined,
          },
          stock: productDetail.stock,
          publicAt: productDetail.publicAt,
          outOfStock: productDetail.outOfStock,
          limitedMeta: productDetail.limitedMeta ?? undefined,
          lowStockMeta: productDetail.lowStockMeta ?? undefined,
        },
        Date.now(),
      );
    }
  }
};
